import { getAdapter } from '@zyf2e/adapt';
import Vue from 'vue';
import { getIM } from '@/constant';

/**
 * 从 search 上获取 params
 */
export const getParamsBySearch = () => {
  const { search } = location;
  if (!search) {
    return {};
  }

  const params = getAdapter().qs.parse(search.substr(1));
  return params;
}

/**
 * 进行跳转, 需要 Vue 实例
 * @param param
 * @param param.type 跳转的类型
 * @param param.url 跳转的链接
 */
export function goto(this: Vue, { type, url }: { type: string; url:string;}) {
  const typeMap = {
    INNER_PAGE: '1',
    WEB_PAGE: '2'
  }

  if (typeMap.WEB_PAGE === type) {
    location.href = url;
    return;
  }

  this.$router.push(url);
}
